<style scoped lang="scss" type="text/scss">
    .sample-photo-dialog {
        .center {
            text-align: center;
        }

        .trigger-text {
            font-size: .75rem;
            color: #AAA;
            transition: all .2s;

            &:hover {
                color: #427DFF;
                cursor: pointer;
            }
        }

        .image-container {
            .sample-photo {
                max-height: 20rem;
            }
        }

        .tip {
            margin-top: 1rem;
        }
    }
</style>

<template>
    <div class="sample-photo-dialog">
        <div :class="{center: center}">
            <span class="trigger-text" @click="show">查看示例图片</span>
        </div>
        <el-dialog :title="totalTitle" class="player-application-popup"
                   :visible.sync="visible"
                   width="50%">
            <div class="image-container">
                <img class="sample-photo" :src="src" alt="">
            </div>
            <info-panel class="tip" v-if="tip !== null && tip !== undefined && tip !== ''">
                {{ tip }}
            </info-panel>
        </el-dialog>
    </div>
</template>

<script>
    import InfoPanel from '../info-panel/index';

    export default {
        name: '',
        components: {
            InfoPanel
        },
        props: {
            center: {
                type: Boolean,
                default: false
            },
            src: String,
            title: String,
            tip: String
        },
        data () {
            return {
                visible: false
            };
        },
        computed: {
            totalTitle () {
                let title = this.title;
                if (title === undefined || title === null) title = '';
                return `正在查看${title}示例图片`;
            }
        },
        methods: {
            show () {
                this.visible = true;
            },
            close () {
                this.visible = false;
            }
        }
    };
</script>
